import { action } from 'satcheljs';
// This action uses the word SharePoint while the rest of the package uses sharing because GetSharingInfo is
// SharePoint specific, so adding a SharePointLink will be a different process than adding an ODC/GDrive link.
// For the rest of the package it shouldn't matter where the link came from, so the more generic term 'sharing' is used.
// TODO VSO 33492: mutators should not take in the object they are mutating as a parameter.
export var addSharePointLink = action('ADD_SHAREPOINT_LINK', function (linkId, sharingLinkIds, response) { return ({
    linkId: linkId,
    sharingLinkIds: sharingLinkIds,
    response: response,
}); });
export var removeSharingLink = action('REMOVE_SHARING_LINK', function (linkId, sharingLinkIds) { return ({
    linkId: linkId,
    sharingLinkIds: sharingLinkIds,
}); });
//# sourceMappingURL=publicActions.js.map